module.exports = __webpack_public_path__ + "img/light-cloudy-rain.db1d09b8.svg";